import React from 'react';
import { Container } from './styles';

type Props = {
  onClick: () => void;
};

export default function LoginButton({ onClick }: Props) {
  return (
    <Container onClick={onClick} data-cy="start-login-button">
      🔒 PDV
    </Container>
  );
}
